export default __webpack_public_path__ + "static/media/ad.8ddf0334.PNG";